// A user's access window is StartDate..EndDate, both inclusive and either open-ended.
// The API compares the UTC calendar date of the stored values, so these helpers do too.

const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;
const pad = (n: number) => String(n).padStart(2, "0");

// "YYYY-MM-DD" of a stored access date (UTC calendar date), or null if unset/invalid.
const toAccessDayKey = (value: any): string | null => {
  if (!value) return null;
  if (typeof value === "string" && DATE_ONLY.test(value)) return value;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d.toISOString().slice(0, 10);
};

// "YYYY-MM-DD" of a date picked in the UI (its local calendar date).
const toPickedDayKey = (value: any): string | null => {
  if (!value) return null;
  if (typeof value === "string" && DATE_ONLY.test(value.slice(0, 10)))
    return value.slice(0, 10);
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

const todayUtcKey = () => new Date().toISOString().slice(0, 10);

// True when the user's EndDate is before today.
export const isAccessEnded = (endDate: any): boolean => {
  const end = toAccessDayKey(endDate);
  return !!end && end < todayUtcKey();
};

// True when the given day falls inside the user's access window. Weekly
// availability only applies inside it. Unknown dates fail open.
export const hasAccessOn = (
  startDate: any,
  endDate: any,
  date: any,
): boolean => {
  const day = toPickedDayKey(date);
  if (!day) return true;
  const start = toAccessDayKey(startDate);
  const end = toAccessDayKey(endDate);
  return (!start || start <= day) && (!end || end >= day);
};
